import {
  FETCH_BETAALMETHODES,
  FETCH_BETAALMETHODE,
  SAVE_BETAALMETHODE,
  TOGGLE_BETAALMETHODE,
  TEST_BETAALMETHODE,
  BETAALMETHODE_ERROR
} from "./types";

const INITIAL_STATE = {
  betaalmethodes: [],
  currentBetaalmethode: null,
  loading: false,
  error: null,
  testResult: null
};

export default function betaalmethodesReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_BETAALMETHODES:
      return {
        ...state,
        betaalmethodes: action.payload,
        loading: false,
        error: null
      };
      
    case FETCH_BETAALMETHODE:
      return {
        ...state,
        currentBetaalmethode: action.payload,
        loading: false,
        error: null
      };
      
    case SAVE_BETAALMETHODE:
      // Update bestaande of voeg nieuwe toe
      const updatedBetaalmethodes = state.betaalmethodes.find(b => b._id === action.payload._id)
        ? state.betaalmethodes.map(b => b._id === action.payload._id ? action.payload : b)
        : [...state.betaalmethodes, action.payload];
        
      return {
        ...state,
        betaalmethodes: updatedBetaalmethodes,
        currentBetaalmethode: action.payload,
        loading: false,
        error: null
      };
      
    case TOGGLE_BETAALMETHODE:
      return {
        ...state,
        betaalmethodes: state.betaalmethodes.map(b => 
          b._id === action.payload._id ? action.payload : b
        ),
        currentBetaalmethode: state.currentBetaalmethode?._id === action.payload._id 
          ? action.payload 
          : state.currentBetaalmethode,
        loading: false,
        error: null
      };
      
    case TEST_BETAALMETHODE:
      return {
        ...state,
        testResult: action.payload,
        loading: false,
        error: null
      };
      
    case BETAALMETHODE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        testResult: null
      };
      
    default:
      return state;
  }
}